import { CoVendedorServicio } from './../../covendedor/servicio/covendedor.service';
import { CoCotizaciondetalle } from './../dominio/CoCotizaciondetalle';
import { PersonamastSelectorComponent } from 'src/app/erp/core/personamast/vista/selector/personamastselector.component';
import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewChildren, AfterContentChecked, Testability, ɵConsole } from '@angular/core';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { MessageService, ConfirmationService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { CoCotizacionPk, CoCotizacion } from '../dominio/CoCotizacion';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { ParametrosmastServicio } from 'src/app/erp/core/parametrosmast/service/parametrosmast.service';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { CoDocumentoServicio } from '../../codocumento/service/codocumento.service';
import { MaFormadePagoService } from 'src/app/erp/core/maformadepago/servicio/maformadepago.servicio';
import { MaUnidadNegocioService } from 'src/app/erp/core/maunidadnegocio/servicio/maunidadnegocio.servicio';
import { AcSucursalService } from 'src/app/erp/core/acsucursal/servicio/acsucursal.servicio';
import { WhAlmacenmastService } from 'src/app/erp/logistica/whalmacenmast/servicio/whalmacenmast.servicio';
import { CoCotizacionServicio } from '../servicio/cotizacion.service';
import { DtoWhItemList } from 'src/app/erp/logistica/whItemmast/dominio/DtoWhItemList';
import { DatePipe } from '@angular/common';
import { PersonamastServicio } from 'src/app/erp/core/personamast/service/personamast.service';
import { WhItemNuevoMastComponent } from './../../../logistica/whItemmast/vista/whItemmast-listado-nuevo.component';
import { WhItemDetalleNuevoComponent } from './../../../logistica/whItemmast/vista/whitemmast-detalle-nuevo.component';
import { FiltroCoCotizacion } from '../dominio/FiltroCoCotizacion';
import { CoPedidosServicio } from '../../pedido/servicio/copedidos.service';
import { WhItemMastServicio } from '../../../../erp/logistica/whItemmast/servicio/WhItemMast.service';
import { Table } from 'primeng/table';

@Component({
    templateUrl: './cocotizacion-mantenimiento-nuevo.component.html'
})

export class CoCotizacionMantenimientoNuevoComponent extends PrincipalBaseComponent implements OnInit {

    bean: CoCotizacion = new CoCotizacion();
    origen: string;
    titulo: string = '';
    verMensaje1: Boolean = false;
    mensaje1: string;
    fila: number = 0;
    dtoPersonamast: DtoPersonamast;
    verModalDescuento: Boolean = false;
    urlImprimir: String = '';
    puedeVerMargen= false;
    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;
    @ViewChild(WhItemNuevoMastComponent,{static:false}) whItemNuevoMastComponent: WhItemNuevoMastComponent;
    @ViewChild(WhItemDetalleNuevoComponent,{static:false}) whItemDetalleNuevoComponent: WhItemDetalleNuevoComponent;
    @ViewChild(Table, { static: false }) dt: Table;
    
    constructor(
        private coCotizacionServicio: CoCotizacionServicio,
        private parametrosmastServicio: ParametrosmastServicio,
        private router: Router,
        private datePipe: DatePipe,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private maFormadePagoService: MaFormadePagoService,
        private maUnidadNegocioService: MaUnidadNegocioService,
        private coVendedorServicio: CoVendedorServicio,
        private acSucursalService: AcSucursalService,
        private personamastServicio: PersonamastServicio,
        private whItemMastServicio:WhItemMastServicio,
        private coPedidosServicio:CoPedidosServicio,
        private whAlmacenmastService: WhAlmacenmastService,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
    ) { super(noAuthorizationInterceptor, messageService); }

    lstEstado: SelectItem[] = [];
    lstAlmacen: SelectItem[] = [];
    lstFormaPago: SelectItem[] = [];
    lstClientes: any[];
    lstSucursal: SelectItem[] = [];
    lstUnidadNegocio: SelectItem[] = [];
    lstMoneda: SelectItem[] = [];
    lstVendedor: SelectItem[] = [];
    editarcliente: Boolean = false;
    action: string;
    actionPantalla: string;
    ib_ControlBotonDsctoBonif: Boolean = true;
    filtro: FiltroCoCotizacion = new FiltroCoCotizacion();
    esAdministrador: Boolean = false;

    ngOnInit() {
        super.ngOnInit();

        this.action = this.route.snapshot.params['accion'];
        this.actionPantalla = this.route.snapshot.params['pantallaAccion'] as string;

        if (this.action === 'VERITEMS') {
        }

        this.bloquearPagina();

        const promises = [];

        this.lstEstado.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'PEDEST').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstado.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
            }
        ));

        this.lstFormaPago.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.maFormadePagoService.listarActivos().then(
            res => {
                res.forEach(
                    reg => {
                        this.lstFormaPago.push({ label: reg.descripcion, value: reg.pk.formadepago.trim() });
                    }
                );
            }
        ));


        this.lstAlmacen.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.whAlmacenmastService.listarActivosHuemura('V').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstAlmacen.push({ label: reg.descripcionLocal, value: reg.almacenCodigo.trim() });
                    }
                );
            }
        ));

        this.lstSucursal.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.acSucursalService.listarActivos().then(
            res => {
                res.forEach(
                    reg => {
                        this.lstSucursal.push({ label: reg.descripcionlocal, value: reg.pk.sucursal.trim() });
                    }
                );
            }
        ));

        this.lstUnidadNegocio.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.maUnidadNegocioService.listarActivos().then(
            res => {
                res.forEach(
                    reg => {
                        this.lstUnidadNegocio.push({ label: reg.descripcionlocal, value: reg.pk.unidadnegocio.trim() });
                    }
                );
            }
        ));

        this.lstVendedor.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.coVendedorServicio.listarActivosDto().then(
            res => {
                res.forEach(
                    reg => {
                        this.lstVendedor.push({ label: reg.vendedorNombre, value: reg.vendedor });
                    }
                );
            }
        ));

        this.coPedidosServicio.esAdministrador().then(
            resp => {
                if (resp !== undefined || resp !== null) {
                    if (resp.esAdministrador === 'S') {
                        this.esAdministrador = true;
                    } else {
                        this.esAdministrador = false;
                    }
                }
            }
        );
        this.coPedidosServicio.puedeVerMargen().then(
            resp => {
                if (resp !== undefined || resp !== null) {
                    if (resp.esAdministrador === 'S') {
                        this.puedeVerMargen = true;
                    } else {
                        this.puedeVerMargen = false;
                    }
                }
            }
        );

        this.lstMoneda.push({ label: ' -- Seleccione -- ', value: null });
        this.lstMoneda.push({ label: 'Local', value: 'LO' });
        this.lstMoneda.push({ label: 'Dólares', value: 'EX' });

        Promise.all([promises]).then(
            x => {
                setTimeout(() => { this.ngOnInit2(); }, 1000);
            }
        );
    }

    onChange(event) {
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: 'Al cambiar la moneda desea que se actualicen los precios segun lista de precios?',
            accept: () => {
                this.bloquearPagina();
                this.coCotizacionServicio.wfSetprecios(this.bean).then(
                    resp => {
                        if (resp !== null) {
                            this.bean = resp;
                            this.desbloquearPagina();
                        } else {
                            this.desbloquearPagina();
                        }
                    }
                );
            }
        });
    }

    ngOnInit2() {

        this.action = this.route.snapshot.params['accion'];
        this.actionPantalla = this.route.snapshot.params['pantallaAccion'] as string;

        if (this.action === 'NUEVO') {
            this.origen = 'cotizacion-listado';
            this.nuevo();
        } else if (this.action === 'EDITAR') {
            this.titulo = 'Editar Cotización';
            this.origen = 'cotizacion-listado';
            const pk = JSON.parse(this.route.snapshot.params['bean']) as CoCotizacionPk;
            this.editar(pk);
        } else if (this.action === 'VER') {
            this.titulo = 'Ver Cotización';
            this.origen = 'cotizacion-listado';
            const pk = JSON.parse(this.route.snapshot.params['bean']) as CoCotizacionPk;
            this.editar(pk);
        } else if (this.action === 'VERITEMS') {
            this.origen = 'cotizacion-listado';
            this.action = this.actionPantalla;
            this.bean = JSON.parse(this.route.snapshot.params['bean']) as CoCotizacion;
            if (this.bean.pk.numerodocumento === undefined) {
                this.titulo = 'Nueva Cotización';
            } else {
                this.titulo = 'Editar Cotización';
            }
            this.desbloquearPagina();
        } else {
            throw new Error('NO CONTROLADO AUN');
        }
    }

    alCerrarCabecera(bean: any) {
        this.origen = 'cotizacion-listado';
        this.bean = bean as CoCotizacion;
        if (this.bean.pk.numerodocumento === undefined) {
            this.titulo = 'Nueva Cotización';
        } else {
            this.titulo = 'Editar Cotización';
        }
    }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;//this.filterClientes(query, res);
            }
        );
    }

    filterClientes(query, countries: any[]): any[] {
        let filtered: any[] = [];
        for (let i = 0; i < countries.length; i++) {
            let country = countries[i];
            if (country.busqueda.trim().toLowerCase().indexOf(query.trim().toLowerCase()) == 0) {
                filtered.push(country);
            }
        }
        return filtered;
    }

    captureId(event: any) {
        this.bean.clientenumero = event.persona;
        this.coCotizacionServicio.actualizarCliente(this.bean).then(
            resp => {
                if (resp !== null) {
                    this.bean = resp;
                }
            }
        );
    }

    filaEditada: boolean = false;
    detalleSeleccionado: CoCotizaciondetalle=new CoCotizaciondetalle();
    habilitarDescuento: Boolean = false;

    onRowEditInit(detalleSeleccionado: CoCotizaciondetalle) {
        this.filaEditada = true;
        if (!this.estaVacio(detalleSeleccionado.descuento04flag)) {
            if ('S' === detalleSeleccionado.descuento04flag) {
                this.habilitarDescuento = false;
            } else {
                this.habilitarDescuento = true;
            }
        }
        this.clonedCars[detalleSeleccionado.itemcodigo] = { ...detalleSeleccionado };
    }

    clonedCars: {
        [s: string]: CoCotizaciondetalle;
    } = {};

    onRowEditCancel(car: CoCotizaciondetalle, index: number) {
        this.filaEditada = false;
        this.bean.coCotizaciondetalle[index] = this.clonedCars[car.itemcodigo];
        delete this.clonedCars[car.itemcodigo];
    }
    documento: CoCotizacion = new CoCotizacion();
    onRowEditSave(detalle: CoCotizaciondetalle) {
        this.detalleSeleccionado = detalle;
        if (!this.validar()) {
            this.filaEditada = false;
            delete this.clonedCars[detalle.itemcodigo];
            this.bean.cantidadItem = detalle.cantidadpedida;
            this.bean.descuento01 = detalle.porcentajedescuento01;
            this.bean.descuento02 = detalle.porcentajedescuento02;
            this.bean.descuento03 = detalle.porcentajedescuento03;
            this.bean.descuento04 = detalle.porcentajedescuento04;
            this.bean.iv_action = 'U';
            this.bean.linea = detalle.pk.linea;
            this.bean.montoTotalDetalle = detalle.monto;
            this.bean.montoMargenDetalle = detalle.margen;
            this.whItemMastServicio.calcularMontosCotizacion(this.bean).then(
                resp => {
                    this.bean = resp;
                    this.desbloquearPagina();
                    this.mostrarMensajeExito('El Item N°' + detalle.itemcodigo + ' se ha actualizado Correctamente');
                    this.dt.reset();
                }
            );
        }
    }

    validar(): Boolean {
        this.filaEditada = false;
        let valida: Boolean = false;

        if(this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento01)){
            this.detalleSeleccionado.porcentajedescuento01=0;
        }
        if(this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento02)){
            this.detalleSeleccionado.porcentajedescuento02=0;
        }
        if(this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento03)){
            this.detalleSeleccionado.porcentajedescuento03=0;
        }
        if(this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento04)){
            this.detalleSeleccionado.porcentajedescuento04=0;
        }

        if ( this.esNumeroVacio(this.detalleSeleccionado.cantidadpedida)) {
            this.mostrarMensajeAdvertencia('Ingrese valor en la cantidad ');
            valida = true;
        }

        if (!this.habilitarDescuento) {
            if (this.detalleSeleccionado.porcentajedescuento04 > this.detalleSeleccionado.porcentajedescuento04_Valid) {
                if (this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento04_Valid)) {
                    this.detalleSeleccionado.porcentajedescuento04_Valid = 0;
                }
                this.mostrarMensajeAdvertencia('El % #4 ingresado excede al máximo permitido x Item ' + this.detalleSeleccionado.porcentajedescuento04_Valid);
                this.detalleSeleccionado.porcentajedescuento04 = this.detalleSeleccionado.porcentajedescuento04_Valid;
                valida = true;
            }
        }


        if (this.detalleSeleccionado.porcentajedescuento02_Valid === null || this.detalleSeleccionado.porcentajedescuento02_Valid === undefined) {
            this.detalleSeleccionado.porcentajedescuento02_Valid = 0;
        }
        if (this.detalleSeleccionado.porcentajedescuento02 > this.detalleSeleccionado.porcentajedescuento02_Valid) {
            this.mostrarMensajeAdvertencia('El % #2 ingresado excede al máximo permitido x Item ' + this.detalleSeleccionado.porcentajedescuento02_Valid);
            this.detalleSeleccionado.porcentajedescuento02 = this.detalleSeleccionado.porcentajedescuento02_Valid;
            valida = true;
        }

        if (this.detalleSeleccionado.porcentajedescuento03_Valid === null || this.detalleSeleccionado.porcentajedescuento03_Valid === undefined) {
            this.detalleSeleccionado.porcentajedescuento03_Valid = 0;
        }
        if (this.detalleSeleccionado.porcentajedescuento03 > this.detalleSeleccionado.porcentajedescuento03_Valid) {
            this.mostrarMensajeAdvertencia('El % #3 ingresado excede al máximo permitido x Item ' + this.detalleSeleccionado.porcentajedescuento03_Valid);
            this.detalleSeleccionado.porcentajedescuento03 = this.detalleSeleccionado.porcentajedescuento03_Valid;
            valida = true;
        }

        return valida;
    }

    nuevo() {
        this.titulo = 'Nueva Cotización';
        let cliente: DtoPersonamast = new DtoPersonamast();
        this.coCotizacionServicio.nuevaCotizacion(cliente).then(
            res => {
                if (res !== null) {
                    this.bean = res;
                    this.desbloquearPagina();
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }

    editar(pk: CoCotizacionPk) {
        this.editarcliente = true;
        pk.companiasocio = pk.companiasocio.trim();
        pk.numerodocumento = pk.numerodocumento.trim();
        this.coCotizacionServicio.obtenerCompletoPorId(pk).then(
            x => {
                if (x !== null) {
                    x.almacencodigo = this.trim(x.almacencodigo);
                    x.iv_action = 'Update';
                    this.bean = x;
                    this.bean.auxFechaDocumento = this.datePipe.transform(this.bean.fechadocumento, "dd/M/yyyy HH:mm:ss");
                    this.dtoPersonamast = new DtoPersonamast();
                    this.dtoPersonamast.busqueda = x.clientenombre;
                    this.dtoPersonamast.persona = x.clientenumero;
                    this.desbloquearPagina();
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }


    autorizarDscto4() {
        this.bean.claveAutorizacion = undefined;
        if (this.bean.coCotizaciondetalle.length == 0) {
            this.mostrarMensajeAdvertencia('Debe de ingresar Items al detalle');
            return;
        }

        this.verModalDescuento = true;
    }

    aceptarAutorizacion() {
        if (this.bean.claveAutorizacion === undefined || this.bean.claveAutorizacion === null) {
            this.mostrarMensajeAdvertencia('Por favor ingresar la contraseña para la autorizacion');
            return;
        }

        this.coCotizacionServicio.obtenerAutorizacionDescuento04(this.bean).then(
            resp => {
                if (resp !== null) {
                    if (resp.pk.numerodocumento !== undefined) {
                        this.bean = resp;
                        this.verModalDescuento = false;
                    }
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });
    }


    calcularDescuentos() {
        this.bean.iv_action = 'Add';
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: 'Se aplicará el cálculo del descuento y bonificación para todo el detalle',
            accept: () => {
                this.bloquearPagina();
                this.coCotizacionServicio.calcularDescuentos(this.bean).then(
                    resp => {
                        if (resp != null) {
                            this.mostrarMensajeExito('El  cálculo del descuento y bonificación se realizó correctamente');
                            this.bean = resp;
                            this.ib_ControlBotonDsctoBonif = false;
                        }
                        this.desbloquearPagina();
                    }
                );
            }
        });
    }

    eliminarItem(coCotizaciondetalle: CoCotizaciondetalle) {
        // para tomar el nuemro del padre
        this.bean.linea = coCotizaciondetalle.pk.linea;

        this.coCotizacionServicio.eliminarDetalle(this.bean).then(
            pedido => {
                if (pedido !== null) {
                    this.bean = pedido;
                    this.mostrarMensajeExito('El registro se ha eliminado correctamente');
                    this.desbloquearPagina();
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }


    imprimir() {
        this.bloquearPagina();
        this.filtro.numerodoc = this.bean.pk.numerodocumento;
        this.filtro.usuarioActualCompania = this.bean.pk.companiasocio;
        this.coCotizacionServicio.imprimir(
            this.filtro
        )
            .then(respuesta => {
                if (respuesta) {
                    this.desbloquearPagina();
                    const file = new Blob([respuesta], { type: 'application/pdf' });
                    this.urlImprimir = URL.createObjectURL(file);
                    window.open(this.urlImprimir.toString());
                }
            });
    }

    customRowClass(rowData, rowIndex): string {
        return rowData.transferenciagratuitaflag === 'S' ? 'transferencia-gratuita-row' : '';
    }

    editarItem(coCotizaciondetalle: CoCotizaciondetalle) {

        const obj: DtoWhItemList = new DtoWhItemList();
        obj.item = coCotizaciondetalle.itemcodigo;
        obj.descripcionLocal = coCotizaciondetalle.descripcion;
        obj.cantidad = coCotizaciondetalle.cantidadpedida;
        obj.porcentajedescuento01 = coCotizaciondetalle.porcentajedescuento01;
        obj.porcentajedescuento02 = coCotizaciondetalle.porcentajedescuento02;
        obj.porcentajedescuento03 = coCotizaciondetalle.porcentajedescuento03;
        obj.porcentajedescuento04 = coCotizaciondetalle.porcentajedescuento04;
        obj.transferenciagratuitaflag = coCotizaciondetalle.transferenciagratuitaflag;
        obj.porcentajedescuento02_Valid = coCotizaciondetalle.porcentajedescuento02_Valid;
        obj.porcentajedescuento03_Valid = coCotizaciondetalle.porcentajedescuento03_Valid;
        obj.descuento04flag = coCotizaciondetalle.descuento04flag;
        this.bean.linea = coCotizaciondetalle.pk.linea;
        this.bean.montoTotalDetalle = coCotizaciondetalle.monto;
        this.bean.montoMargenDetalle = coCotizaciondetalle.margen;
        this.whItemDetalleNuevoComponent.iniciarModal('EDITAR', 'COTIZACION', 'S', this.bean, obj);
    }


    cancelar() {

        if (this.origen === 'COTIZACION') {
            this.router.navigate(['/royal/cotizacion-listado'], { skipLocationChange: true });
        } else if (this.origen === 'cliente-listado') {
            this.router.navigate(['/royal/cliente-listado', 'COTIZACION'], { skipLocationChange: true });
        } else {
            this.router.navigate(['/royal/' + this.origen], { skipLocationChange: true });
        }

    }

    agregarItems() {
        //sessionStorage.setItem('filtrosItemCotizacion', 'LIMPIAR');

        if (this.bean.clientenumero == null || this.bean.clientenumero == undefined) {
            this.mostrarMensajeAdvertencia('Seleccionar un cliente');
            return;
        }

        if (this.bean.almacencodigo === null) {
            this.mostrarMensajeAdvertencia('Seleccionar un cliente con almacén');
            return;
        }
        if (this.bean.vendedor === null) {
            this.mostrarMensajeAdvertencia('No hay un vendedor asignado');
            return;
        }
        if (this.bean.sucursal === null) {
            this.mostrarMensajeAdvertencia('Seleccionar sucursal');
            return;
        }
        if (this.action === 'NUEVO') {
            this.bean.iv_action = 'Add';
        } else {
            this.bean.iv_action = 'Update';
        }

        const almacen = this.bean.almacencodigo;
        this.whItemNuevoMastComponent.iniciarModal('COTIZACION', almacen, this.action, 'N', this.bean);
    }

    verItemPedido() {
        if (this.bean.coCotizaciondetalle.length < 1) {
            this.mostrarMensajeAdvertencia('No existe registros para mostrar');
            return;
        }

        if (this.action === 'NUEVO') {
            this.bean.iv_action = 'Add';
        } else {
            this.bean.iv_action = 'Update';
        }

        this.origen = 'COTIZACION';
    }


    registrar() {

        if (this.filaEditada == true) {
            this.mostrarMensajeExito('Existen Filas en el detalle que no han sido completadas con la validacion');
            return;
        }

        this.bloquearPagina();
        if (this.action === 'NUEVO') {
            this.bean.iv_action = 'Add';
        } else {
            this.bean.iv_action = 'Update';
        }



        if (this.ib_ControlBotonDsctoBonif) {
            this.confirmationService.confirm({
                header: 'Confirmación',
                icon: 'fa fa-question-circle',
                message: 'Usted ejecuto el botón Calcular Dscto. \ Bonif. ?',
                accept: () => {
                    this.bloquearPagina();
                    this.coCotizacionServicio.validarCotizacion(this.bean).then(
                        resp => {
                            if (resp.length > 0) {
                                this.fila = 0;
                                for (let i = 0, len = resp.length; i < len; i++) {
                                    if (resp[i].tipoMensaje.toString() === 'ADVERTENCIA') {
                                        this.fila++;
                                        this.mensaje1 = resp[i].mensaje;
                                    }
                                }

                                // tslint:disable-next-line:triple-equals
                                if (this.fila == resp.length) {
                                    this.verMensaje1 = true;
                                } else {
                                    this.messageService.addAll(this.getMensajesUsuario(resp));
                                    this.desbloquearPagina();
                                }
                            } else {
                                this.desbloquearPagina();
                                this.guardarCotizacion();
                            }
                        }
                    );
                }
            });
            this.desbloquearPagina();
        } else {
            this.coCotizacionServicio.validarCotizacion(this.bean).then(
                resp => {
                    if (resp.length > 0) {
                        this.fila = 0;
                        for (let i = 0, len = resp.length; i < len; i++) {
                            if (resp[i].tipoMensaje.toString() === 'ADVERTENCIA') {
                                this.fila++;
                                this.mensaje1 = resp[i].mensaje;
                            }
                        }

                        // tslint:disable-next-line:triple-equals
                        if (this.fila == resp.length) {
                            this.verMensaje1 = true;
                            this.desbloquearPagina();
                        } else {
                            this.messageService.addAll(this.getMensajesUsuario(resp));
                            this.desbloquearPagina();
                        }
                    } else {
                        this.desbloquearPagina();
                        this.guardarCotizacion();
                    }
                }
            );
            this.desbloquearPagina();
        }
    }

    guardarCotizacion() {
        this.bloquearPagina();
        this.ib_ControlBotonDsctoBonif = false;
        this.coCotizacionServicio.registrar(this.bean).then(
            pedido => {
                if (pedido !== null) {
                    this.bean = pedido;
                    this.getMensajeGrabado(pedido.pk.numerodocumento);
                    this.mostrarMensajeExito('La cotización N° ' + this.bean.pk.numerodocumento + ' se ha guardado correctamente');
                    this.desbloquearPagina();
                    this.router.navigate(['/royal/cotizacion-listado', 'GRABADO'], { skipLocationChange: true });
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }

    cancelarAccionSelector() {
    }

    cargarCliente(bean: DtoPersonamast) {
        this.bloquearPagina();
        this.bean.clientenumero = bean.persona;
        this.bean.clientenombre = bean.busqueda;
        this.coCotizacionServicio.actualizarCliente(this.bean).then(
            resp => {
                if (resp !== null) {
                    this.desbloquearPagina();
                    this.bean = resp;
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }


    mostrarSelectorCliente() {
        this.personamastSelectorComponent.iniciarComponente();
    }
    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }


}



